import React, { useLayoutEffect, useState } from "react";
import FlowEdge from "../../../workflows/CreateCampaign/flow/edges/FlowEdge";
import TrailEdge from "../../../workflows/CreateCampaign/flow/edges/TrailEdge";
import StartNode from "../../../workflows/CreateCampaign/flow/nodes/StartNode";
import TrailNode from "../../../workflows/CreateCampaign/flow/nodes/TrailNode";
import BaseNode from "../../../workflows/CreateCampaign/flow/nodes/BaseNode";
import { handleLayout } from "../../../workflows/CreateCampaign/flow/layouter";
import {
  Badge,
  Button,
  Flex,
  Group,
  Paper,
  Switch,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import NodeActionPanel from "../../../workflows/CreateCampaign/flow/panel/NodeActionPanel";
import ReactFlow, { Background, Controls, ReactFlowProvider } from "reactflow";
import { useFlowStore } from "../../../../../stores/WorkflowStore";
import BackButton from "../../../../../components/View/BackButton";
import {
  IconArrowRight,
  IconUserCancel,
  IconUserExclamation,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import WorkflowListingModal from "../../../workflows/listing/WorkflowListingModal";
import { useProfileStore } from "../../../../../stores/UserStore";
import PopupNew from "../../../workflows/CreateCampaign/flow/PopupNew";

const edgeTypes = {
  main: FlowEdge,
  trail: TrailEdge,
};

const nodeTypes = {
  start: StartNode,
  trail: TrailNode,
  action: BaseNode,
};

const NurturingFlow = ({ nurturing, setActiveStep }) => {
  const loadingPage = useFlowStore((s) => s.loadingPage);
  const lang = useLanguage((s) => s.language);
  const nodes = useFlowStore((s) => s.nodes);
  const edges = useFlowStore((s) => s.edges);
  const flowProfile = useFlowStore((s) => s.profile);

  useLayoutEffect(() => {
    handleLayout();

    let minStateButton = document.getElementById("min-state-button");

    if (minStateButton) {
      minStateButton.click();
    }
  }, []);

  const handleSwitch = () => {
    useFlowStore.getState().setLayout("horizontal");
  };

  return (
    <>
      <Paper component={Group} p={"md"} gap={"xl"} withBorder>
        <Title order={4}>{lang.prm.nurturing.step3.title}</Title>
        <Text>{lang.prm.nurturing.step3.text}</Text>
      </Paper>
      <Flex
        flex={1}
        style={{ overflow: "hidden" }}
        mah={
          nurturing?.id === "create"
            ? "calc(100vh - 290px)"
            : "calc(100vh - 300px)"
        }
      >
        <Tooltip
          label={lang.workflows.configs.exclude_answerers}
          refProp="rootRef"
        >
          <Switch
            key={flowProfile?.id}
            size="md"
            onLabel={<IconUserCancel size={18} />}
            offLabel={<IconUserExclamation size={18} />}
            defaultChecked={flowProfile.auto_remove_responders}
            onChange={(e) =>
              useFlowStore.getState().setProfile({
                ...useFlowStore.getState().profile,
                auto_remove_responders: e.target.checked,
              })
            }
            name="auto_remove_responders"
            pos={"absolute"}
            left={4}
            style={{ zIndex: 8 }}
          />
        </Tooltip>
        <ReactFlowProvider>
          <ReactFlow
            id="workflow"
            nodes={nodes}
            nodeTypes={nodeTypes}
            edges={edges}
            // onNodesChange={handleNodesChange}
            connectOnClick={false}
            panOnScroll
            panOnScrollMode="vertical"
            panOnDrag={true}
            zoomOnScroll={false}
            preventScrolling
            // fitView
            defaultEdgeOptions={{
              type: "main",
              deletable: false,
              focusable: false,
              updatable: false,
            }}
            edgeTypes={edgeTypes}
            disableKeyboardA11y
            nodesDraggable={false}
            proOptions={{
              hideAttribution: true,
            }}
            defaultViewport={{
              x:
                useFlowStore.getState().selectedNode && nodes.length > 2
                  ? window.innerWidth / 4 - 196
                  : window.innerWidth / 4,
              y: useFlowStore.getState().selectedNode
                ? useFlowStore.getState().selectedNode?.y + 132
                : -32,
              zoom: 1,
            }}
            translateExtent={[
              [-Infinity, 32],
              [Infinity, Infinity],
            ]}
            nodeExtent={[
              [-Infinity, 32],
              [Infinity, Infinity],
            ]}
            maxZoom={1}
            edgesUpdatable={false}
            edgesFocusable={false}
          >
            <Background />
            <Controls position="bottom-right" showInteractive={false} />

            {nodes.length < 3 &&
              !loadingPage &&
              useProfileStore?.getState().profile.show_new_workflow_builder ===
                null && <PopupNew />}

            <Button
              variant="outline"
              bg={"#fff"}
              pos={"fixed"}
              top={256}
              right={128}
              style={{ zIndex: 600 }}
              size="md"
              leftSection={
                <Badge color="#ffd6d6" c={"black"}>
                  Bêta
                </Badge>
              }
              radius={"lg"}
              onClick={handleSwitch}
            >
              {lang.campaign.popup_new.btn_test_new}
            </Button>
          </ReactFlow>

          <NodeActionPanel inSheet />
        </ReactFlowProvider>

        <WorkflowListingModal nurturing />

        <Paper
          component={Group}
          p={"md"}
          mt={"md"}
          gap={"lg"}
          pos={"absolute"}
          bottom={16}
          left={16}
        >
          <BackButton
            label={lang.global.back}
            onClick={() => setActiveStep("contacts")}
            size="md"
          />

          <Button
            onClick={() => setActiveStep("program")}
            size="md"
            rightSection={<IconArrowRight />}
          >
            {lang.global.next}
          </Button>
        </Paper>
      </Flex>
    </>
  );
};

export default NurturingFlow;
